import { ZodFormattedError } from 'zod'
import PublisherComponent from '@Components/ViewWork/PublisherComponent'
import SharesInfo from '@Components/ViewWork/SharesInfo'
import React from 'react'
import { Maybe } from '@Types'
import { observer } from 'mobx-react'
import { WorkType } from '@Components/ViewWork/work-type'
import { RightsholderContact } from '@Entities/rightsholder/rightsholder-contact'
import { PublisherModel } from '@Entities/work/publisher-model'
import { OriginalPublisherModel } from '@Entities/work/original-publisher-model'

interface PublisherListProps {
    publishers: OriginalPublisherModel[]
    publisherErrors?: ZodFormattedError<OriginalPublisherModel[]>
    totalKnownShares: number
    myShares?: number
    workType?: WorkType
    getPubContactByIpId(pub: PublisherModel): Maybe<RightsholderContact>
}

const PublisherList = (props: PublisherListProps) => {
    const { publishers, publisherErrors, totalKnownShares, myShares, getPubContactByIpId, workType } = props
    return (
        <>
            {publishers.map((op, opIdx) =>
                op.administratorPublishers.length ? (
                    op.administratorPublishers.map((ap, apIdx) => (
                        <PublisherComponent
                            key={opIdx + '-' + apIdx}
                            publisher={op}
                            publisherError={publisherErrors?.[opIdx]}
                            admin={ap}
                            adminPublisherError={publisherErrors?.[opIdx]?.administratorPublishers?.[apIdx]}
                            publicContact={getPubContactByIpId(ap)}
                            workType={workType}
                        />
                    ))
                ) : (
                    <PublisherComponent
                        key={opIdx}
                        publisher={op}
                        publisherError={publisherErrors?.[opIdx]}
                        publicContact={getPubContactByIpId(op)}
                        workType={workType}
                    />
                )
            )}
            <SharesInfo totalShares={totalKnownShares} myShares={myShares} />
        </>
    )
}
export default observer(PublisherList)
